import { ThemeOptions } from '@mui/material/styles';
import { baseComponents, baseSpacing, baseTypography } from './baseTheme';

/**
 * Pro2 - Corporate Slate
 * A dense, enterprise-focused theme with muted slate/navy tones, an amber
 * accent, sharper corners and crisp borders for a data-focused workspace.
 * Primary: Deep Slate Navy (#16324f)
 * Secondary: Amber (#b45309)
 */
export const pro2Theme: ThemeOptions = {
    palette: {
        mode: 'light',
        primary: {
            main: '#16324f',
            light: '#3a5a7d',
            dark: '#0d2136',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#b45309',
            light: '#d97706',
            dark: '#92400e',
            contrastText: '#ffffff',
        },
        background: {
            default: '#eceff3',
            paper: '#ffffff',
        },
        text: {
            primary: '#0f172a',
            secondary: '#475569',
        },
        divider: '#dfe4ea',
        error: {
            main: '#b91c1c',
        },
        warning: {
            main: '#b45309',
        },
        info: {
            main: '#0369a1',
        },
        success: {
            main: '#15803d',
        },
    },
    typography: {
        ...baseTypography,
        h1: { fontSize: '1.6rem', fontWeight: 700 },
        h2: { fontSize: '1.4rem', fontWeight: 700 },
        h3: { fontSize: '1.2rem', fontWeight: 700 },
        h4: { fontSize: '1.05rem', fontWeight: 700 },
        h5: { fontSize: '0.95rem', fontWeight: 700 },
        h6: { fontSize: '0.85rem', fontWeight: 700 },
    },
    spacing: baseSpacing,
    shape: {
        borderRadius: 4,
    },
    components: {
        ...baseComponents,
        MuiButton: {
            defaultProps: { size: 'small', disableElevation: true },
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                    minHeight: 28,
                    padding: '4px 12px',
                    borderRadius: 4,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    border: '1px solid #dfe4ea',
                    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: '10px 14px',
                    borderBottom: '1px solid #eef1f4',
                    backgroundColor: '#f7f9fb',
                },
                title: { fontSize: '0.875rem', fontWeight: 700, color: '#16324f' },
                subheader: { fontSize: '0.72rem' },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: { backgroundImage: 'none' },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#0f2540',
                    borderRight: 'none',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    color: '#0f172a',
                    borderBottom: '1px solid #dfe4ea',
                    boxShadow: 'none',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '4px 8px',
                    fontSize: '0.8125rem',
                    borderColor: '#e5e9ef',
                },
                head: {
                    fontWeight: 700,
                    padding: '6px 8px',
                    backgroundColor: '#eef2f6',
                    color: '#16324f',
                    textTransform: 'uppercase',
                    letterSpacing: '0.03em',
                    fontSize: '0.72rem',
                },
            },
        },
    },
};
